"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgAirplay = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24.768 26.36l5 6A1 1 0 0129 34H19a1 1 0 01-.768-1.64l5-6a1 1 0 011.536 0zM24 28.562L21.135 32h5.73L24 28.562zM32 14a3 3 0 013 3v10a3 3 0 01-3 3h-1a1 1 0 010-2h1a1 1 0 001-1V17a1 1 0 00-1-1H16a1 1 0 00-1 1v10a1 1 0 001 1h1a1 1 0 010 2h-1a3 3 0 01-3-3V17a3 3 0 013-3h16z",
    id: "airplay_svg__a"
  }));
};

var _default = SvgAirplay;
exports.default = _default;